import React from 'react'

import { Settings } from 'lucide-react'

import { Button } from '@harvey-frontend/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@harvey-frontend/components/ui/dropdown-menu'
import { Icon } from '@harvey-frontend/components/ui/icon/icon'

import { useAccessTokenContext } from '../providers/AccessTokenProvider'

const Menu = () => {
  const { logoutHandler } = useAccessTokenContext()
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          data-testid="menu-button"
          variant="secondary"
          className="h-[24px] w-[24px]"
        >
          <Icon icon={Settings} size="small" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={logoutHandler}>Logout</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default Menu
